import { gaMeasurementId, gaApiSecret } from '../constants/env'

export const postGAEvent = ({ event, clientId }) => {
  if (event && gaMeasurementId && gaApiSecret) {
    // Post to Google Analytics endpoint
    return fetch(
      `https://www.google-analytics.com/mp/collect?measurement_id=${gaMeasurementId}&api_secret=${gaApiSecret}`,
      {
        method: 'post',
        body: JSON.stringify({
          client_id: clientId ?? 'GUEST',
          events: [event],
        }),
      }
    )
  }
}
